import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { TWITCH_REDIRECT_URI, TWITCH_CLIENT_ID } from '../../../utils/config';
import { setStorageItem } from '../../../libs/bridge/local-storage';
import { STORAGE_ITEM_TWITCH_CONNECT_PREVIOUS_PATH } from '../../../utils/constants/keys';

function ConnectTwitch() {
  const handlePrevPath = () => {
    setStorageItem(
      STORAGE_ITEM_TWITCH_CONNECT_PREVIOUS_PATH,
      window.location.pathname
    );

    window.open(
      `https://id.twitch.tv/oauth2/authorize?client_id=${TWITCH_CLIENT_ID}&redirect_uri=${TWITCH_REDIRECT_URI}&response_type=code&scope=user:edit%20user:read:email`
    );
  };

  return (
    <ClickableDiv
      onClick={handlePrevPath}
      className="flex w-full items-center justify-center gap-3 text-white"
      rel="noreferrer"
    >
      <IcoMoonIcon iconName="twitch" className="size-4" />
      <span className="text-text200 font-semibold">Connect Twitch</span>
    </ClickableDiv>
  );
}

export default ConnectTwitch;
